import React from 'react';
import VipCard from './vipCard';

export default (props) => <VipCard {...props} />;
